module.exports = __webpack_public_path__ + "static/media/close-icon.bf9f249f.svg";